import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import BankTransferListViewModel from "viewModels/finance/bankExports/bankTransfers/bankTransferListViewModel";
import { registerView } from "@frui.ts/views/dist";
import BankExportListView from "../bankExportListView";

const BankTransferListView: ViewComponent<BankTransferListViewModel> = observer(({ vm }) => {
  return <BankExportListView vm={vm} />;
});

registerView(BankTransferListView, BankTransferListViewModel);
